<template>
  <div class="cf-lo">
    <section class="cf-lo__card">
      <header class="cf-lo__head">
        <span class="cf-lo__icon">
          <v-icon size="22" color="white">mdi-vote</v-icon>
        </span>
        <div class="cf-lo__titles">
          <h2 class="cf-lo__title">LO Votes List</h2>
          <p class="cf-lo__desc">
            Voting rights of each LO, with the reason behind every count
          </p>
        </div>
        <span
          class="cf-lo__count"
          v-if="!LoadingFlag && tableData1 && tableData1.length"
          >{{ tableData1.length }} LOs</span
        >
      </header>

      <div class="cf-lo__body">
        <!-- Loading -->
        <loading-spinner v-if="LoadingFlag" />

        <!-- No Records -->
        <div v-else-if="!tableData1 || !tableData1.length" class="no-results">
          <span class="cf-empty__icon">
            <v-icon size="30">mdi-poll</v-icon>
          </span>
          <p>No LO votes available</p>
        </div>

        <!-- Data Table -->
        <div v-else class="cf-lo__table">
          <v-data-table
            :headers="tableheader1"
            :items="tableData1"
            :items-per-page="10"
            class="elevation-0 cf-table"
          >
            <!-- LOM Name -->
            <template #[`item.LomName`]="{ item }">
              <span class="cf-lo__lom">{{ item.LomName }}</span>
            </template>

            <!-- President Name -->
            <template #[`item.LomPresidentFullName`]="{ item }">
              <span>{{ item.LomPresidentFullName }}</span>
            </template>

            <!-- Aadhaar Verified -->
            <template v-slot:[`item.AadhaarVerified`]="{ item }">
              <v-chip
                :color="item.AadhaarVerifiedColor"
                draggable
                dark
                small
                class="cf-lo__chip"
                >{{ item.AadhaarVerified }}</v-chip
              >
            </template>
            <!-- Voting Count -->
            <template v-slot:[`item.VotingCount`]="{ item }">
              <div class="cf-lo__votes">
                <span
                  class="cf-votes"
                  :class="
                    item.VotingCount == 0 ? 'cf-votes--zero' : 'cf-votes--ok'
                  "
                >
                  {{ item.VotingCount }}
                </span>

                <!-- Eye button to open description -->
                <v-btn
                  icon
                  small
                  class="cf-lo__eye"
                  aria-label="View voting description"
                  :loading="rowLoadingMap[item.LomId] || false"
                  @click="showDescription(item)"
                >
                  <v-icon small>mdi-eye-outline</v-icon>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </div>
      </div>
    </section>
    <v-dialog
      v-model="descriptionDialog"
      max-width="600px"
      scrollable
      content-class="rounded-dialog cf-lo-dialog"
    >
      <v-card class="cf-dialog">
        <v-card-title class="cf-dialog__head">
          <span class="cf-dialog__icon">
            <v-icon color="white" size="20">mdi-file-document-outline</v-icon>
          </span>
          <span class="cf-dialog__title">Voting Description</span>
        </v-card-title>

        <v-card-text class="cf-dialog__body">
          <div class="popup-description" v-html="selectedDescription"></div>
        </v-card-text>

        <v-card-actions class="cf-dialog__foot">
          <v-spacer></v-spacer>
          <v-btn
            depressed
            class="cf-dialog__close"
            @click="onCloseDescription"
            :loading="dialogClosing"
          >
            <v-icon left size="18">mdi-close</v-icon>
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
export default {
  name: "LoVotesList",
  mixins: [common],
  props: {
    year: {
      type: [Number, String],
      required: false,
      default: "",
    },
    zone: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    type: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      LoadingFlag: false,
      Records: [],
      PresidentInfo: {},
      tableData1: [],
      tableheader1: [],
      descriptionDialog: false,
      selectedDescription: "",
      // per-row loading for actions like view description
      rowLoadingMap: {},
      dialogClosing: false,
    };
  },

  methods: {
    resetForm() {
      this.$refs.form2.reset();
      this.tableData1 = [];
    },
    showDescription(item) {
      // show per-row loader while opening dialog
      if (item && item.LomId) this.$set(this.rowLoadingMap, item.LomId, true);
      // Check if VotingDescription exists; fallback if missing
      this.selectedDescription =
        item.VotingDescriptionTxt1 || "<em>No description available.</em>";
      // small timeout to allow loader to show
      setTimeout(() => {
        this.descriptionDialog = true;
        if (item && item.LomId) this.$set(this.rowLoadingMap, item.LomId, false);
      }, 180);
    },
    viewSSCard(path) {
      if (path) {
        window.open(path, "_blank");
      } else {
        this.toast("error", "SS Card file not found");
      }
    },

    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      this.searchForm();
      // var url1 = "api/menu-details/show";
      // var condition1 = {
      //   UserInterface: 1,
      //   Module: "voting_rights",
      //   Action: "list_1",
      // };
      // this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    pageData() {
      console.log("pageData called");
    },

    getLoVoteRecords() {
      console.log("searchForm called");

      this.SearchFlag = true;
      this.LoadingFlag = true;
      this.tableData1 = [];
      this.PresidentInfo = {};

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/reports/voting-rights/lists";
      var upload = {
        UserInterface: 2,
        Zone: this.zone,
        Year: this.year,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      const thisIns = this;
      var output = "";
      var records = [];
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          // thisIns.pageLoadingOff()
          thisIns.SearchFlag = false;
          thisIns.LoadingFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          console.log("output=" + output + ", flag=" + flag);

          records = response.data.records;
          console.log({ records });

          thisIns.PresidentInfo = records.PresidentInfo;

          console.log({ PresidentInfo: thisIns.PresidentInfo });

          if (flag == 1) {
            thisIns.tableData1 = records.TableData;
            thisIns.tableheader1 = records.TableHeader;
            console.log({ tableheader1: thisIns.tableheader1 });
            thisIns.toast("success", output);
          } else {
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          thisIns.LoadingFlag = false;
          console.log("error=" + error);
          thisIns.SearchFlag = false;
        });
    },
    hidePreviewRecordPrompt(flag) {
      console.log("hidePreviewRecordPrompt called");
      console.log({ flag });
      this.previewRecordPrompt = false;
      if (flag) {
        this.searchForm();
      }
    },
    previewData(tr) {
      console.log("previewData called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.previewRecordPrompt = true;
        this.selectedData = tr;
      } else {
        var message = "Kindly select one record to preview";
        this.toast("error", message);
      }
    },
    hideApprovalRecordPrompt(flag) {
      console.log("hideApprovalRecordPrompt called");
      console.log({ flag });
      this.approvalRecordPrompt = false;
      if (flag) {
        this.searchForm();
      }
    },
    onCloseDescription() {
      // show a tiny closing animation/loading before actually closing
      this.dialogClosing = true;
      setTimeout(() => {
        this.descriptionDialog = false;
        this.dialogClosing = false;
      }, 220);
    },
    approveData(tr) {
      console.log("approveData called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.approvalRecordPrompt = true;
        this.selectedData = tr;
      } else {
        var message = "Kindly select one record to approve";
        this.toast("error", message);
      }
    },
  },

  mounted() {
    this.getLoVoteRecords();
  },
};
</script>

<style lang="scss" scoped>
/* JCI approved palette */
.cf-lo,
.cf-dialog {
  --navy: #3a67b1;
  --aqua: #0097d7;
  --gold: #edbe38;
  --seafoam: #56bda3;
  --ink: #0a0f29;
  --text: #414042;
  --danger: #c53030;
  --muted: #6b7280;
  --line: #e3e9f3;
  --line-strong: #cdd8ea;
  --surface-tint: #f5f7fc;
  --ease: cubic-bezier(0.22, 0.61, 0.36, 1);
  --ease-out: cubic-bezier(0.16, 1, 0.3, 1);

  color: var(--text);
  font-family: "Poppins", "Roboto", sans-serif;
}

/* ---------- Card ---------- */
.cf-lo__card {
  position: relative;
  overflow: hidden;
  border-radius: inherit;
}
.cf-lo__head {
  position: relative;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px 16px;
  padding: 18px 22px;
  color: #ffffff;
  background: radial-gradient(
      120% 180% at 100% 0%,
      rgba(86, 189, 163, 0.45),
      transparent 55%
    ),
    linear-gradient(120deg, var(--navy), var(--aqua));

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background-image: linear-gradient(
        rgba(255, 255, 255, 0.07) 1px,
        transparent 1px
      ),
      linear-gradient(90deg, rgba(255, 255, 255, 0.07) 1px, transparent 1px);
    background-size: 26px 26px;
    mask-image: linear-gradient(90deg, transparent 20%, #000 90%);
    -webkit-mask-image: linear-gradient(90deg, transparent 20%, #000 90%);
    pointer-events: none;
  }
}
.cf-lo__icon {
  position: relative;
  z-index: 1;
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.3);
  transition: transform 280ms var(--ease);
}
.cf-lo__card:hover .cf-lo__icon {
  transform: rotate(-6deg) scale(1.05);
}
.cf-lo__titles {
  position: relative;
  z-index: 1;
  flex: 1 1 220px;
  min-width: 0;
}
.cf-lo__title {
  margin: 0;
  font-size: 1.12rem;
  font-weight: 700;
  color: #ffffff;
}
.cf-lo__desc {
  margin: 2px 0 0;
  font-size: 0.82rem;
  color: rgba(255, 255, 255, 0.85);
}
.cf-lo__count {
  position: relative;
  z-index: 1;
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--ink);
  background: var(--gold);
  box-shadow: 0 8px 18px -10px rgba(237, 190, 56, 0.9);
  white-space: nowrap;
}
.cf-lo__body {
  padding: 18px 22px 20px;
}

/* ---------- Empty ---------- */
.no-results {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 28px 16px;
  text-align: center;
  border: 1.5px dashed var(--line-strong);
  border-radius: 16px;
  background: var(--surface-tint);
  animation: cf-fade 500ms var(--ease-out);

  p {
    margin: 12px 0 0;
    font-size: 0.88rem;
    font-weight: 500;
    color: var(--muted);
  }
}
.cf-empty__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #ffffff;
  border: 1px solid var(--line);
  box-shadow: 0 10px 24px -14px rgba(58, 103, 177, 0.6);

  .v-icon {
    color: var(--aqua) !important;
  }
}

/* ---------- Table ---------- */
.cf-lo__table {
  animation: cf-fade 500ms var(--ease-out);
}

/* ---------- Premium data table ---------- */
.cf-table.v-data-table {
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid var(--line);
  background: #ffffff;
  font-family: inherit;

  ::v-deep .v-data-table__wrapper {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 440px;
    overscroll-behavior: contain;
    scrollbar-width: thin;
    scrollbar-color: rgba(58, 103, 177, 0.3) transparent;
  }
  ::v-deep .v-data-table__wrapper::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  ::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb {
    background-color: rgba(58, 103, 177, 0.3);
    border-radius: 3px;
  }
  ::v-deep .v-data-table__wrapper > table > thead > tr > th {
    position: sticky;
    top: 0;
    z-index: 2;
    height: 42px;
    padding: 0 14px;
    background: var(--surface-tint);
    border-bottom: 1px solid var(--line-strong) !important;
    color: var(--ink) !important;
    font-size: 0.74rem !important;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    white-space: nowrap;
  }
  ::v-deep .v-data-table__wrapper > table > thead > tr > th.active,
  ::v-deep .v-data-table__wrapper > table > thead > tr > th:hover {
    color: var(--navy) !important;
  }
  ::v-deep .v-data-table__wrapper > table > tbody > tr > td {
    height: 56px;
    padding: 6px 14px;
    font-size: 0.88rem !important;
    color: var(--text);
    border-bottom: 1px solid var(--line) !important;
  }
  ::v-deep .v-data-table__wrapper > table > tbody > tr:last-child > td {
    border-bottom: 0 !important;
  }
  ::v-deep
    .v-data-table__wrapper
    > table
    > tbody
    > tr:hover:not(.v-data-table__expanded__content):not(
      .v-data-table__empty-wrapper
    ) {
    background: rgba(58, 103, 177, 0.05) !important;
  }
  ::v-deep .v-data-footer {
    padding: 4px 8px;
    border-top: 1px solid var(--line) !important;
    font-size: 0.8rem;
    color: var(--muted);
  }
  ::v-deep .v-data-footer .v-btn:not(.v-btn--disabled) .v-icon {
    color: var(--navy);
  }
  ::v-deep .v-data-table__mobile-row {
    min-height: 44px;
  }
  ::v-deep .v-data-table__mobile-row__header {
    font-size: 0.74rem;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: var(--muted);
  }
  ::v-deep .v-data-table__mobile-table-row > td:last-child {
    border-bottom: 1px solid var(--line-strong) !important;
  }
}

.cf-lo__lom {
  font-weight: 600;
  color: var(--ink);
}
.cf-lo__chip.v-chip {
  font-weight: 600;
  letter-spacing: 0.02em;
}
.cf-lo__votes {
  display: flex;
  align-items: center;
  gap: 8px;
}
.cf-votes {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 28px;
  padding: 0 10px;
  border-radius: 9px;
  font-size: 0.9rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}
.cf-votes--ok {
  color: #ffffff;
  background: linear-gradient(135deg, var(--seafoam), #3d9c84);
  box-shadow: 0 8px 16px -10px rgba(86, 189, 163, 0.9);
}
.cf-votes--zero {
  color: #a32626;
  background: rgba(197, 48, 48, 0.1);
  border: 1px solid rgba(197, 48, 48, 0.35);
}
.cf-lo__eye.v-btn {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: rgba(58, 103, 177, 0.1);
  transition: transform 180ms var(--ease), background-color 180ms var(--ease);

  .v-icon {
    color: var(--navy) !important;
  }
  &:hover {
    transform: translateY(-2px);
    background: rgba(58, 103, 177, 0.18);
  }
  &:focus-visible {
    outline: 3px solid rgba(0, 151, 215, 0.45);
    outline-offset: 2px;
  }
}

/* ---------- Description dialog ---------- */
.cf-dialog.v-card {
  border-radius: 20px !important;
  overflow: hidden;
}
.cf-dialog__head.v-card__title {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  color: #ffffff;
  background: linear-gradient(120deg, var(--navy), var(--aqua));
}
.cf-dialog__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.3);
}
.cf-dialog__title {
  font-size: 1.05rem;
  font-weight: 700;
}
.cf-dialog__body.v-card__text {
  padding: 20px !important;
  color: var(--text);
}
.popup-description {
  padding: 14px 16px;
  border-radius: 14px;
  background: var(--surface-tint);
  border: 1px solid var(--line);
  border-left: 4px solid var(--aqua);
  font-size: 0.9rem;
  line-height: 1.7;
  color: var(--text);

  ::v-deep p:last-child {
    margin-bottom: 0;
  }
}
.cf-dialog__foot.v-card__actions {
  padding: 12px 20px 16px;
  border-top: 1px solid var(--line);
}
.cf-dialog__close.v-btn {
  height: 40px;
  padding: 0 18px;
  border-radius: 12px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.01em;
  color: #ffffff;
  background: linear-gradient(135deg, var(--navy), var(--aqua)) !important;
  transition: transform 180ms var(--ease), box-shadow 180ms var(--ease);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 22px -12px rgba(58, 103, 177, 0.9);
  }
}

@media (max-width: 599px) {
  .cf-lo__head {
    padding: 16px;
  }
  .cf-lo__body {
    padding: 14px 12px 16px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .cf-lo *,
  .cf-lo *::before,
  .cf-dialog * {
    animation: none !important;
    transition: none !important;
  }
}

@keyframes cf-fade {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
</style>
